import { FC } from 'react'
import { Box, Text } from '@mrshmllw/smores-react'

interface Props {
  searchTerm: string
  type: 'occupation' | 'industry' | 'country' | 'modification'
}

export const NoSearchResultsFound: FC<Props> = ({ searchTerm, type }) => {
  const getDescription = () => {
    switch (type) {
      case 'occupation': {
        return `It might be listed differently. For example, if you're a "PR Consultant", try "Public Relations Officer" instead.`
      }
      case 'industry': {
        return `Sometimes we use different terms. If you're in "Medical services," try "Healthcare."`
      }

      case 'country': {
        return `The country might be listed differently. If you took your test in the "UAE," try "United Arab Emirates."`
      }
      case 'modification': {
        return `The modification might have another name. If you're looking for "Muffler system modifications,” try "Exhaust upgrades."`
      }
      default: {
        return false
      }
    }
  }

  return (
    <Box>
      <Text typo="headline-regular">No matches for {`'${searchTerm}'`}.</Text>
      {!!getDescription() && <Text mt="8px">{getDescription()}</Text>}
    </Box>
  )
}
